import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { SCRAPPER_API } from "../../../../../../../../../../../shared/services/scrapping";
import Loading from "../../../../../../../../../../../shared/components/Loading";
import ProveedorPocoFiableModal from "../ProveedorPocoFiableModal";
import { setErrorMessage } from '../../../../../../../../../../../shared/helpers/functionalities';

export default function ScrappingForm({
    onScrapping
}) {
    const { register, formState: { errors }, handleSubmit: handleSubmitURL } = useForm();
    const [scrapping, setScrapping] = useState(null);
    const [showUnreliableModal, setShowUnreliableModal] = useState(false);
    const [isScrapping, setIsScrapping] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    
    // metodo para obtener la URL y hacer scrapping
    const onSubmit = async (data, e) => {
        e.preventDefault();
        setIsScrapping(true);
        setIsLoading(true);
        try {
            const res = await SCRAPPER_API.scrappingURL(data);
            if(res?.success) {
                let scrappingData = res.data;
                return onScrapping(scrappingData, data);
            }
            const message = res?.message ?? 'ERROR! URL no válida o no se ha podido obtener la información'
            toast.error(message);
            
        } catch (e) {
            toast.error(setErrorMessage(e))
        } finally {
            setIsLoading(false);
            setIsScrapping(false);
        }
        
    };

    const handleScrapping = (confirm) => {
        if(confirm) onScrapping(scrapping.scrappingData, scrapping.data);
        else {
            setScrapping(null);
            setShowUnreliableModal(false);
        }
    }

    return (
        <>
            { (isLoading) && <Loading /> }

            { (!isLoading) &&
                <form className="d-flex align-self-center mt-2" onSubmit={handleSubmitURL(onSubmit)}>
                    <div className="form-group mb-0">
                        <input 
                            type="text" 
                            className="form-control" 
                            placeholder="URL pieza"
                            {...register("url", { required: true })} 
                            defaultValue='' />

                        <div className="form-invalid">
                            {errors.url?.type === 'required' && "URL es obligatoria"}
                        </div>
                    </div>

                    <button type="submit" disabled={isScrapping} className="btn btn-primary ms-2">Scrapping</button>
                </form>
            }

            { (showUnreliableModal && scrapping) &&
                <ProveedorPocoFiableModal
                    pieza={scrapping.scrappingData}
                    onConfirmAction={handleScrapping} 
                    state={showUnreliableModal}>
                </ProveedorPocoFiableModal>
            }
            
        </>
    );
}